export default __webpack_public_path__ + "static/media/nex-ten-bot-right.5b0b4baa.png";